import React, {Component} from 'react';
import {Link, withRouteData} from 'react-static';
import styled from 'styled-components';

import OutroBackground from './OutroThree';

const OutroStyle = styled.div`
	position: relative;
	padding-bottom: 9.375rem;
	
	.row {
		position: relative;
	}
	h2 {
		margin-bottom: 5rem;
		color: #83F5F8;
		text-shadow: 0 0 2px #83F5F8;
	}
	
	.outro-background {
		z-index: -1;
		opacity: 0.75;
		height: 66.66vh;
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		transition: opacity 2000ms ease;
	}
	.outro-background::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.00) 50%, rgba(0, 0, 0, 1) 100%);
	}

`;

class Outro extends Component {
	render() {

		return (
			<OutroStyle className="text-center">
				<div className="outro-background">
					<OutroBackground />
				</div>
				<div className="container">
					<div className="row">
						<div className="columns medium-9 small-centered">
							<h2>{this.props.outro.seekingInvestors}</h2>
							{/* <a className="button button--big" href="https://firstblockchain.fund/business-invite/an0kphtdmoyt2opxe">{ this.props.navigation.becomeBacker }</a> */}
							<Link className="button button--big" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/signup`}>{this.props.navigation.becomeBacker}</Link>
						</div>
					</div>
				</div>
			</OutroStyle>
		)
	}
}

export default withRouteData(Outro)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Outro.js